module.exports = __webpack_public_path__ + "static/img/illust_1_mk.9145344f.svg";